module.exports = __webpack_public_path__ + "static/media/o1.06f3d9ee.svg";